var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "url(#paint0_linear_0_1)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3628 24.6636C20.4194 24.1494 22.0086 23.1211 23.1771 21.5787C24.3924 20.083 25 18.2601 25 16.1568C25 14.8013 24.7196 13.7262 24.0652 12.8849C23.4576 12.0436 22.6162 11.5762 21.5412 11.5762C20.6064 11.5762 19.8585 11.8566 19.2976 12.3708C18.7835 12.9317 18.503 13.6328 18.503 14.4741C18.503 15.3154 18.7835 15.9698 19.3444 16.5307C19.9053 17.0916 20.5596 17.3253 21.3075 17.3253C21.8216 17.3253 22.1956 17.2785 22.3825 17.1851C22.3825 18.3068 22.0553 19.3351 21.3075 20.2699C20.6064 21.2515 19.6248 21.9526 18.3628 22.3265V24.6636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.72 24.6636C12.7766 24.1494 14.3658 23.1211 15.5343 21.5787C16.7495 20.083 17.3572 18.2601 17.3572 16.1568C17.3572 14.8013 17.0767 13.7262 16.4224 12.8849C15.8147 12.0436 14.9734 11.5762 13.8984 11.5762C12.9636 11.5762 12.2157 11.8566 11.6548 12.3708C11.1407 12.9317 10.8602 13.6328 10.8602 14.4741C10.8602 15.3154 11.1407 15.9698 11.7016 16.5307C12.2624 17.0916 12.9168 17.3253 13.6647 17.3253C14.1788 17.3253 14.5527 17.2785 14.7397 17.1851C14.7397 18.3068 14.4125 19.3351 13.6647 20.2699C12.9636 21.2515 11.982 21.9526 10.72 22.3265V24.6636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -14,
    y1: 68.5,
    x2: 60.3739,
    y2: 44.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComment);
export default __webpack_public_path__ + "static/media/ico-comment.918b3ac15f3d2ecaf72b4612506bf3ed.svg";
export { ForwardRef as ReactComponent };